function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { Menu } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Power, HouseFill, Image, CapsulePill, PersonCheck, PersonLinesFill, LungsFill, PersonVcardFill, Speedometer, Clipboard2PulseFill, Building, CheckCircleFill, PieChartFill, PeopleFill, GearFill, EarFill, EyeFill, HeartPulseFill, Eyedropper } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();

  var _useState = useState('day'),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var handleClick = function handleClick(e) {
    setCurrent(e.key);

    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
  };

  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    theme: "dark",
    style: {
      background: "#B7693F"
    },
    onClick: handleClick,
    selectedKeys: current,
    mode: "vertical",
    children: [(Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/cashier",
        children: /*#__PURE__*/_jsx("b", {
          children: "ID Candidats"
        })
      })
    }, "day"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Eyedropper, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/laboratoire",
        children: /*#__PURE__*/_jsx("b", {
          children: "LABORATOIRE"
        })
      })
    }, "lab"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Clipboard2PulseFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/consultations",
        children: /*#__PURE__*/_jsx("b", {
          children: "QUESTIONNAIRES"
        })
      })
    }, "chech"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Image, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/imagerie",
        children: /*#__PURE__*/_jsx("b", {
          children: "IMAGERIE"
        })
      })
    }, "im"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(EarFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/audio",
        children: /*#__PURE__*/_jsx("b", {
          children: "TESTE AUDIO"
        })
      })
    }, "audio"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(EyeFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/visio",
        children: /*#__PURE__*/_jsx("b", {
          children: "TESTE VISIO"
        })
      })
    }, "visio"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(LungsFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/spiro",
        children: /*#__PURE__*/_jsx("b", {
          children: "SPIROMETRIE"
        })
      })
    }, "spiro"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PersonCheck, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/vaccin",
        children: /*#__PURE__*/_jsx("b", {
          children: "VACCIN"
        })
      })
    }, "vaccin"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PersonLinesFill, {
        style: {
          color: "#FFFFFF"
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/hrview",
        children: /*#__PURE__*/_jsx("b", {
          children: "RECAPITULATIF"
        })
      })
    }, "hr"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(CheckCircleFill, {
        style: {
          color: "#FFFFFF"
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/conclusion",
        children: /*#__PURE__*/_jsx("b", {
          children: "CONCLUSION"
        })
      })
    }, "valid"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Building, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/companies",
        children: /*#__PURE__*/_jsx("b", {
          children: "SOCIETES"
        })
      })
    }, "comps"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PersonVcardFill, {
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/evolution",
        children: /*#__PURE__*/_jsx("b", {
          children: "CANDIDATS"
        })
      })
    }, "cand"), (Common.currentUser.role == 0 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PeopleFill, {
        style: {
          color: 'FBB91D'
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users",
        children: /*#__PURE__*/_jsx("b", {
          children: "UTILISATEURS"
        })
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(GearFill, {
        style: {
          color: 'FBB91D'
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig",
        children: /*#__PURE__*/_jsx("b", {
          children: "COMPTE"
        })
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: '#B7403F'
        },
        size: 26
      })
    }, "quit")]
  });
};

export default UserNavBar;